var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useLayoutEffect } from 'react';
import { camel, only } from '@pcty/utils';
/**
 * Validates input and registers it with the Form on mount
 *
 * @param {string} id The id
 * @param {string | undefined} label The label of the input
 * @param {T} value The current value of the input
 * @param {boolean} userManagedValidation Whether or not the component validation is manually controlled by the user
 * @param {(value: T) => V} getValidation Callback for getting the current Validation value
 * @param {(value: SetStateAction<V>) => void} setValidation Setter for managing validation internally
 * @param {(id: string, validation: FV) => void} updateForm Action to dispatch updates to the Form
 */
export var useValidationOnMount = function (id, label, value, userManagedValidation, getValidation, setValidation, updateForm) {
    useLayoutEffect(function () {
        var validation = getValidation(value);
        setValidation(only(validation, ['valid', 'errorMessage']));
        if (userManagedValidation)
            return;
        updateForm(camel(id), __assign(__assign({}, validation), { value: value, id: id, label: label, dirty: false }));
    }, []);
};
